import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
    container: { padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto' },
    card: { background: 'var(--card-background)', padding: '2rem', borderRadius: '8px', boxShadow: 'var(--shadow-md)' },
    nav: { listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column' },
    navLink: {
        display: 'block',
        padding: '1rem',
        background: '#f9f9f9',
        margin: '0.5rem 0',
        borderRadius: '6px',
        textDecoration: 'none',
        color: 'var(--primary-color)',
        fontWeight: 500,
        transition: 'all 0.2s'
    }
};

const HomePage = () => {
    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2>Menu Principale</h2>
                <ul style={styles.nav}>
                    <li><Link to="/" style={styles.navLink}>Home</Link></li>
                    <li><Link to="/report-passaggi" style={styles.navLink}>Report Passaggi</Link></li>
                    {/* Aggiungi qui altri link */}
                </ul>
            </div>
        </div>
    );
};

export default HomePage;